import * as React from "react"

export const ListAddIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.764 17.083a1.3 1.3 0 0 1-.962-.388 1.3 1.3 0 0 1-.385-.952V5.256q0-.562.389-.951t.95-.388h10.488q.563 0 .951.388.39.39.389.951v6.73a4 4 0 0 0-.533-.149 5 5 0 0 0-.55-.08v-6.5a.25.25 0 0 0-.08-.177.25.25 0 0 0-.177-.08H4.757a.25.25 0 0 0-.177.08.25.25 0 0 0-.08.176v10.487q0 .096.08.177.081.08.177.08h5.461a3.4 3.4 0 0 0-.04.534q0 .272.035.55zm9.663 2.209v-2.25h-2.25v-1.084h2.25v-2.25h1.083v2.25h2.25v1.083h-2.25v2.25zm-7.632-4.985q.276 0 .467-.186a.62.62 0 0 0 .19-.463.64.64 0 0 0-.187-.467.62.62 0 0 0-.463-.191.64.64 0 0 0-.467.187.62.62 0 0 0-.19.463q0 .276.186.467.188.19.464.19m0-3.153q.276 0 .467-.187a.62.62 0 0 0 .19-.463.64.64 0 0 0-.187-.467.62.62 0 0 0-.463-.191.64.64 0 0 0-.467.187.62.62 0 0 0-.19.463q0 .276.186.467.188.19.464.19m0-3.154q.276 0 .467-.187a.62.62 0 0 0 .19-.463.64.64 0 0 0-.187-.467.62.62 0 0 0-.463-.19.64.64 0 0 0-.467.186.62.62 0 0 0-.19.463q0 .276.186.467.188.19.464.19M9.08 11.04h4.744V9.958H9.08zm0-3.153h4.744V6.804H9.08zm0 6.307h1.69q.163-.296.371-.563.21-.267.441-.52H9.08z"
    ></path>
  </svg>
)
